var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "gh-list-item" },
    [
      _c("GenerationHistoryListItemHead", {
        attrs: {
          "service-name-key": _vm.serviceNameKey,
          "project-name": _vm.item.project_name,
          datetime: _vm.item.request_datetime_ts,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gh-list-item__body gh-list-item__body--half" },
        [
          _c("div", { staticClass: "gh-list-item__left" }, [
            _c("div", { staticClass: "gh-list-item__preview" }, [
              _c(
                "div",
                { staticClass: "gh-list-item__preview-text" },
                [
                  _c("vue-markdown", {
                    staticClass: "markdown-custom",
                    attrs: { source: _vm.previewText, "task-lists": false },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "gh-list-item__view-all",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("view-all", _vm.item.project_id)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(_vm.viewAllKey, { count: _vm.item.total_count })
                    ) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gh-list-item__right" },
            [
              _c("GenerationHistoryMetaRows", {
                attrs: {
                  fields: _vm.inlineFields,
                  variant: "inline",
                  "row-key-prefix": `naming-${_vm.item.project_id}`,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }